var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookDefault = function SvgFacebookDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.484 0H3.516A3.52 3.52 0 0 0 0 3.516v16.968A3.52 3.52 0 0 0 3.516 24h7.078v-8.484H7.78v-4.22h2.813V8.439a4.223 4.223 0 0 1 4.219-4.22h4.265v4.22h-4.265v2.859h4.265l-.703 4.219h-3.563V24h5.672A3.52 3.52 0 0 0 24 20.484V3.516A3.52 3.52 0 0 0 20.484 0z",
    fill: "#FFF"
  })));
};
export default SvgFacebookDefault;